import React, { Component } from 'react';
import DropDown2 from './DropDown2'

const apiValues = ["Fahrenheit", "Celsius",];
const display = ["Fahrenheit", "Celsius",];

export default class TempDropdown extends Component {
  constructor(props) {
    super(props);

    this.apiValues = apiValues;
    this.state = { options: display, }
  }
  render () {
    const dd2 = TempDisplay (this.props?.value)
    return <DropDown2 {...this.state} {...this.props} value={dd2}
        onUpdate={(param)=>this.props.onUpdate (this.apiValues[param], this.props)}/>
  }
}

export function TempDisplay (apiValue) {
  apiValue = apiValue ?? ''
  const found = apiValues.indexOf(apiValue)
  return found < 0 ? (apiValue ? apiValue : "Not Available") : display[found]
}
